export default {
    site: {
        common: {
            hello: "hello",
            forMoreInfo: "Pentru mai multe informatii",
            hoverOverColumnHeaders: "Hover over the column headers for more information.",
            username: "username",
            score: "scor",
            points: "puncte",
            chapter: "capitol",
            tier: "categorie",
            t1: "T1",
            t2: "T2",
            t3: "T3",
            collectionsPerDay: "Colectari pe zi",
            relicBoostPercent: "Stimulent relicve %",
            mountainHallPercentShort: "MTN. Hall %", // used in table heading keep it short.
            updated: "actualizat",
            lastUpdated: "Ultima actualizare",
            created: "creat",
            role: "rol",
            Fellow: 'Membru',
            Ambassador: 'Ambasador',
            Mage: 'Mag',
            Archmage: 'Arhemag',
            saveChanges: "Salveaza schimbarile",
            copy: "Copiaza",
            close: "Inchide",
            cancel: "Anuleaza",
            action: "Actiune",
            date: "Data",
            Left: "Ramas",
            Joined: "Alaturat",
            human: "om",
            elf: "elf",
            search: "Cauta",
            enter: "Intra",
            yes: "Da",
            no: "Nu",
            tournament: "Turnir",
            tournaments: "Turniruri",
            fellowship: "Fratie",
            player: "Jucator",
            member: "Membru",
            history: "Istoric",
            tournamentHistory:  "Istoric turnir",
            scoreHistory: "Istoric scor",
            server: "Server",
            lastWeekGain: "Castigul saptamanii trecute",
            comingSoon: "In curand",
            chest: "cufar",
            yourServer: "Serverul tau",
            allServers: "Toate Serverele",
            boosts: "Stimulente",
            marble: "marmura",
            steel: "otel",
            planks: "cherestea",
            crystal: "cristal",
            scrolls: "pergamente",
            silk: "matase",
            elixir: "elixir",
            magic_dust: "praf magic",
            gems: "pietre pretioase",
            average: "mediu",
            expansions: 'Extinderi', // 5x5 grids
        },
        // HIGH PRIORITY
        nav: {
            home: "Acasa",
            players: "Jucatori",
            fellowships: "Fratii",
            tournaments: "Turniruri",
            contact: "Contact",
            donate: "Doneaza",
            faq: "FAQ",
            news: "Noutati",
            privacyPolicy: "Politica de confidentialitate",
            me: "Eu",
            myFellowship: "Fratia Mea",

            // NOTE USED AT THE MOMENT
            globalStats: "Statistici Globale",
            articles: "Articole",
            fellowshipAdventure: "Aventurile Fratiei",
            recruit: "Recruteaza",
        },
        // VERY HIGH PRIORITY!
        elvenArchitect: {
            viewCityOnElvenArchitect: "Vizualizeaza orasul pe ElvenArhitect"
            ,obtainingLink: "Obtine Link"
            ,successMessage: "Reusit! Click pe link-ul de ma jos pentru a lansa Elven Architect"
            ,ageOfLink: "Link-ul de mai jos iti va arata orasul asa cum era: "
            ,clickToGetCurrentCity: "<-- Apasa pentru orasul curent",
        },
        playerSelection: {
            headline: "Vizualizeaza pagina ca",
            description: "Actualizarea informatiilor specifice utilizatorilor site-ului.  Exemple: fratia mea, utilizatorul meu, turnee si statistici.",
            youAreViewing: `Acum vizualizezi pagina ca {username} pe {serverName}.`,
            changeUser: "Schimba jucator",
            enterYourUsernameToGetStarted: "Introdu numele de utilizator din Elvenar pentru a incepe",
            thisIsNotASignup:"Acesta nu este un proces de autentificare.  Introducand numele de utilizator, we simply customize the site appropriately.  Sunt multe servere de Elvenar si se vor afisa rezultate pentru serverul tau.De asemenea, vor fi disponibile link-uri cu fratia ta si pagina ta personala."
        },
        searchBoxes: {
            enterFellowshipName: 'Introdu numele fratiei',
            instructions: "Scrie aici numele si selecteaza fratia.",
            noFellowship: "Nicio Fratie",
        },
        relativeTime: {
            // Relative time strings - note: these aren't yet implemented in the code
            daysAgo: "zile in urma",
            minsAgo: "minute in urma",
            hoursAgo: "ore in urma",
            justNow: "chiar acum",
            never: "Niciodata",
        },

        home: {
            welcome: "Bine ati venit pe Elven Stats!",
            youAreViewing: "Esti conectat pe site cu {username} pe {serverName}",
            youCanChange: "Poti schimba utilizatorul apasand pe avatar -sau- folosind <router-link to='/contact'>accesand pagina</router-link>",
            features: {
                headline: "Caracteristici",
                fellowshipAdministration: {
                    headline: "Administrarea fratiei <strong>SIMPLU</strong>",
                    bullet1: "Urmarirea automata a marfurilor preferate pentru a echilibra nevoile fratiei",
                    bullet2: "Urmarirea automata si raportarea saptamanala incluzand punte, participare turneu, crestere lunara si sprijin, performanta personala",
                    bullet3: "Identificarea productiei membrilor fratiei care produce dezechilibre de resurse",
                },
                elvenArchitectIntegration: {
                    headline: "<strong>Integrat cu </strong>ElvenArchitect",
                    description: "Preluarea orasului propriu in ElvenArchitect in cateva secunde! Planifica o mai buna organizare si detectarea de spatiu necesar! Cauta logo ElvenArchitect in paginile jucatorilor."
                },
                advancedRankingLists: {
                    headline: "<strong>Clasamente </strong>avansate",
                    bullet1: "Clasament zone deblocate (comparativ cu altii la acelasi nivel de dezvlotare)",
                    bullet2: "Vizualizare sporuri, numar de capitol si altele in Lista jucatori.",
                },
                fellowshipTournamentTracking: {
                    headline: "<strong>Urmarire </strong>turneu fratie",
                    description: "Clasament fratie. Provocarea altei fratii la o competitie prieteneasca!",
                },
                matchMaking: {
                    headline: "Match <strong>Making</strong>",
                    description: "ElvenStats tracks players boosts and the goods production ratios of fellowships.  With this information, fellowships can recruit the right candidates to balance their goods. Users looking for a fellowship can find fellowships that actually NEED their boosts. Saving time and reducing rejection!"
                }
            }
        },
        fellowship: {
            stats: {
                rank: "Rang",
                points: "Puncte",
                medianUserScore: "Scor <strong>mediu</strong>",
                memberCount: "Membri<strong>Count</strong>",
            },
            barCharts: {
                clickSlice: "Aoasa pe o coloana pentru detalii (by member)",
                tier1: "Cat. 1",
                tier2: "Cat. 2",
                tier3: "Cat. 3",
                drillDown: "Inapoi la {0}"
            },
            idealCandidate: {
                heading: "Candidatul Ideal",
                description: "Ar avea un scor in jur de {medianScore} si ar avea una sau mai multe marfuri sporite de tipul: {boosts}",
                note: "Anumite combinatii de marfuri sporite nu sunt posibile. Vezi {0}"
            },
            memberGoodsTable: {
                heading: "Productia de marfuri",
                description: `This table computes how much of each good your fellowship makes. We took an educated guess as to what your
                respective members boost percentages were and by default we're assuming each member does 3 collections per day
                (2x9h and 1x3h). To improve the accuracy, ask your fellowship members what their actual values are and enter them below. You can
                save what you enter so it will show up next time you load this page. The bar charts above will update automatically after you make changes. Hover over the column
                headers for more information about a particular column.'
                `,
                refreshButtonText: 'Refresh Member List',
                refreshButtonTip: 'This will add new members, remove old members, update fellowship roles, and update current scores.',
                inactiveWarningTip: 'User may be inactive, Score Last Updated: {0}',
                collectsPerDayValidation: "Must be between 1-6",
                boostPercentValidation: "Must be between 40 - 700, do not include bonus from mountain halls",
                perDayShort: "/zi",

                // HIGH PRIORITY - IMPORTANT TOOLTIPS
                scoreTip: "The players score, please note this is not updated in realtime.  It's updated several times a week.",
                chapterTip: "Capitolul in care se afla fiecare jucator.  De exemplu: Elementali = 12, Pitici = 11, etc.",
                boostTip: "Stimulentul membrilor si cantitatea ce se produce zilnic.",
                collectsPerDayTip: `***EDITABLE*** <br/>Collects Per Day. This is the number of times per day the user collects goods from their manufacturies. It should be a value from 1 - 6.  1 = 1x24h, 2=2x9h, 3=2x9h + 1x3h, 4=1x9h + 3x3h, 5=4x3h + 1x9h, 6=5x3h + 1x9h<BR/>Please see the FAQ for more.`,
                relicBoostPercentTip: `***EDITABLE***<br/>The boost percent from relics, it's between 40-700.  It should not include the players Mountain Hall Percent.  That is detected automatically and added to this number`,
                mountainHallPercentTip: "This is the Mountain Hall Boost Percentage we detected for this user.  It is used in conjunction with the boost %'s to calculate total boost percent.",
                updatedTip: "This is the when the players city was last analyzed.  This process is what sets the boosts, elven architect data, calculates production from all manufactories, mountain hall %, and more. City map data is periodically fetched automatically but you can force an update below by clicking the refresh button.",

            },
            coinsAndSuppliesTable: {
                heading: "Productie Monede / Provizii",
                description: `The key column here is "Supplies Left" as it indicates whether a member will produce enough supplies to keep their
                manufactories producing 24/7.  Use the toggle switches below to take into account the players minimum culture boost (which is the boost you'd have if you had no neighborly help)
                and/or the number of times the member collects per day (as specified in Goods Table above).  Turning both off is useful if you want to see how much of the supplies are attributed
                to more manufactories or a higher culture boost. Finally, please note that having low negative (~10% of total) number of supplies left is fairly common. There are many ways players
                supplement their supplies such as by visiting neighbors, producing supplies at faster intervals (Beverages, Simple Tools, Bread...) or using Power of Provision spells.
                Think of the negative value as what you'd need to make up on a daily basis by doing one of these options.
                NOTE: at the moment troop production is not taken into account in the supplies used (Only Tier 1, Tier 2, and Tier 3 goods) so you may need more.`,

                // These are the column text that show up under the icons. Keep them short.
                minBoostPercent: "Min Boost %",
                made: "Produs",
                used: "Folosit",
                left: "Ramas",

                // TOOL TIPS
                minimumCultureBoostPercent: "The culture boost percentage.  IMPORTANT: this is calculated assuming NO NEIGHBORLY HELP to culture buildings. In reality, this will likely be higher in your cities.",
                moneyComputedTip: "The amount of coins produced in a day, includes any Ancient Wonders that produce coins",
                moneyUsedComputedTip: "The amount of coins consumed by producing goods.",
                moneyRemainingComputedTip: "Coins - Coins Used, it's the surplus or deficit in coins a player will have each day",
                suppliesComputedTip: "The number of supplies that would be produced if all workshops were set to 24x1 (Toolboxes) + any ancient wonders. (does not include set bonuses)",
                suppliesUsedComputedTip: "The number of supplies consumed by producing goods. DOES NOT include supplies used by your barracks! See explanation above.",
                suppliesRemainingComputedTip: "Supplies - Supplies Used, it's the surplus or deficit in supplies a player will have each day",
                manaTip: "The amount of Mana produced in 24 Hours (does not include Dragon Abbey)",
            },
            popCultureTable: {
                heading: "Informatii Populatie/Cultura",
                description: 'Tabelul de mai jos arata Populatia/Cultura pentru fiecare membru. Vezi antetele coloanelor pentru mai multe informatii.',

                // Icon Sub-Headings
                minBoostPercent: "Min Boost %",
                levels: "Nivele",
                total: "Total",
                working: "Lucreaza",
                available: "Disponibil",
                required: "Necesar",

                // Low Priority - Tool Tips
                wonderLevelsTip: "The total number of ancient wonder levels a player has.",
                cultureBoostPercentTip: "The culture boost percentage.  IMPORTANT: this is calculated assuming NO NEIGHBORLY HELP to culture buildings. In reality, this will likely be higher in your cities.",
                totalPopulationTip: "Total Culture produced by residences, culture/population hybrid buildings and ancient wonders",
                workingPopulationTip: "Working Population - The amount consumed by buildings",
                availablePopulationTip: "Available Population",
                totalCultureTip: "Total Culture produced by culture buildings, culture/population hybrid buildings and ancient wonders",
                requiredCultureTip: "Required Culture needed for all your buildings",
                availableCultureTip: "Available Culture",
            },
            cityCoverageTable: {
                heading: "City Coverage",
                description: "Shows how many tiles are used in each members city for the particular building type. The empty tiles are tiles which are currently not being used.",
                tiles: 'Tiles'
            },

            // HIGH PRIORITY TO TRANSLATE
            weeklyReport: {
                heading: "Raport saptamanal pe e-mail",
                description: "Noi generam automat rapoarte adecvate pentru a le impartasi cu membri fratiei voastre. Un nou raport saptamanal va fi valabil Duminica (aproximativ ora 8pm UTC) pentru saptamana trecuta . Copiaza textul si distribuie !",
                selectReportHint: "Select Report for Week Ending On",
                reportsAreOptimizedFor: "Rapoartele sunt optimizate pentru a putea fi afisate in sistemul de mesagerie al Elvenar pentru a putea incapea intr-un singur mesaj.",
                accolades: "acolade",
                tourneyChamp: " - Campionul Turnirului (this week): {0}",
                tourneyHero: " - Eroul Turnirului (last 4 weeks): {0}",
                highestGrowthPlusPercentage: " - Dezvoltare ( puncte si procent ) : {0}",
                highestGrowthPoints: " - Cea mai mare Dezvoltare (puncte): {0}",
                highestGrowthPercentage: " - Cea mai mare dezvoltare (procent): {0}",
                highestGrowthError: " - Cea mai mare Dezvoltare: nu poate fi determinata momentan, avem nevoie de mai mult istoric",
                newPersonalRecords: "Recorduri personale noi",
                userSetANewPersonalRecordFor: " * {0} Seteaza un nou record personal pentru: {1}",
                allMembersByPointGainThisWeek: "Toti membrii - puncte obtinute / procent (this week)",
                tournamentPointsHeader: "Puncte Turnir (this week / TOTAL SINCE {0})",
                top8ByPercentage: "TOP 8 in Procente (this week)",
                top8ByPointsSince: "TOP 8 in Puncte (Since {0})",
                top8ByPercentageSince: "TOP 8 in Procente (Since {0})",
                reportGeneratedBy: "Raport generat de elvenstats.com, pentru mai multe detalii vezi: ",
                mostPointsInAWeek: "Cele mai multe puncte / saptamana",
                highestTournamentScore: "Cel mai mare scor la Turnir",
                highestTournamentRank: "Cel mai mare rang la Turnir",
                insufficientHistoryForThesePlayers: "* Omitted: {0} due to insufficient history.  They will be included next week",
                insufficientHistory1Week: "* Insufficient History for this section. Check back next week!",
                insufficientHistory4Weeks: "* Insufficient History for this section. 4 weeks of history is needed. Check back soon!",
            },
            memberHistory: {
                heading: "Member History",
                noChangesDetected: "No member changes detected yet since fellowship tracking began on {0}"
            },
            notifications: {
                unsavedChanges: 'You have unsaved changes. When finished editing your fellowship click the save button.',
                standbyImporting: 'Standby: We are importing some of your fellows that are missing information',
                limitedHistory: "We very recently began tracking this {0} so there is limited history.  Each Sunday, weekly snapshots will show up here so be sure to check back soon!",
                noChangesSinceTrackingBegan: "Nicio schimbare de cand urmarirea a inceput",
            }
        },
        player: {
            fellowshipHistory: {
                heading: "Istoricul Fratiei"
            }
        },
        status: {
            realTimeUpdatesNotAvailableHeadline: "Actualizarile in timp real sunt indisponibile momentan.",
            realTimeUpdatesNotAvailableDescription: "This typically occurs after the Elvenar Game Servers are restarted to deploy an update or for maintenance. Once this occurs, ElvenStats must manually login to all game servers before information can be retrieved on demand.  Please try your request in a couple hours.  In the meantime, the site is fully functional otherwise.",
            copyToClipboardSuccessful: "Copy To Clipboard Successful!",
            copyToClipboardFailed: "Failed to copy, highlight the entire text area and then do CTRL+C",
            errorOccurredImporting: "Error Occurred. Importing your users.",
            errorOccurredImportingMessage: "An error occurred trying to import your users.  Please try again.  If the error, persists please contact us.",
            errorOccurredImportingWillNotBeAvailableInReports: "Utilizatorii ce nu au fost importati nu vor fi inclusi in rapoartele saptamanale.",
            finishedSyncSuccessful: "Finalizat, Sincronizarea a avut succes!",
            playerIsAnonymous: "Jucatorul a solicitat ca informatiile sa nu fie afisate pe elvenstats.com",
            inactiveWarningTip: "Acest jucator ar putea fi inactiv.   Ultima schimbare a scorului: {0}",
            isFriendTip: "Acest jucator este un prieten al ElvenStats. Ei fie au contribuit cu timp sau bani pentru a sustine acest site "


        }
    }
}


// WEBPACK FOOTER //
// ./src/lang/ro.js